import React from 'react';
import { motion } from 'framer-motion';

function StatBar({ label, value, maxValue = 255, color = 'blue' }) {
  const percentage = Math.min((value / maxValue) * 100, 100);
  
  const colorClasses = {
    red: 'bg-red-500',
    orange: 'bg-orange-500',
    yellow: 'bg-yellow-500',
    green: 'bg-green-500',
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    purple: 'bg-purple-500',
    pink: 'bg-pink-500'
  };

  return (
    <div className="flex items-center space-x-3">
      <div className="w-20 text-sm font-medium text-gray-700 text-right">
        {label}
      </div>
      <div className="flex-1 bg-gray-200 rounded-full h-3 relative overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className={`h-full rounded-full progress-bar ${colorClasses[color] || colorClasses.blue}`}
        />
      </div>
      <div className="w-12 text-sm font-semibold text-gray-900 text-right">
        {value}
      </div>
    </div>
  );
}

export default StatBar;